import React, { Component, Fragment } from 'react'
import { Row, Card, CardTitle } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import { Colxx } from '../components/common/CustomBootstrap'
import IntlMessages from '../helpers/IntlMessages'


class Error extends Component {
  componentDidMount() {
    document.body.classList.add('background')
  }

  componentWillUnmount() {
    document.body.classList.remove('background')
  }

  render() {
    return (
      <Fragment>
        <div className="fixed-background" />
        <main>
          <div className="container">
            <Row className="h-100">
              <Colxx xxs="6" md="5" className="mx-auto my-auto text-center">
                <Card className="auth-card">
                  <div className="form-side">
                    <NavLink to="/" className="white">
                      <span className="logo-single" />
                    </NavLink>
                    <CardTitle className="mb-4">
                      <IntlMessages id="Ooops... looks like an error occurred!" />
                    </CardTitle>
                    <p className="mb-0 text-muted text-small mb-0">
                      <IntlMessages id="Error code" />
                    </p>
                    <p className="display-1 font-weight-bold mb-5">404</p>
                    <NavLink to="/app" color="primary" className="btn btn-primary">
                      <IntlMessages id="GO BACK HOME" />
                    </NavLink>
                  </div>
                </Card>
              </Colxx>
            </Row>
          </div>
        </main>
      </Fragment>
    )
  }
}
export default Error
